<aside class="fixed left-0 top-0 h-screen w-64 bg-gray-50 flex flex-col z-50">
  <!-- Logo Header -->
  <div class="p-6 border-b border-gray-200">
    <div class="flex items-center gap-3">
      <img src="/logo.svg" alt="Strong Towing" class="h-8 w-auto" />
    </div>
  </div>

  <!-- Navigation -->
  <nav class="flex-1 overflow-y-auto py-4 flex flex-col">
    <ul class="space-y-1 px-3">
      @for (item of menuItems; track item.route) {
        <li>
          @if (item.children && item.children.length > 0) {
            <!-- Parent item with children - navigates on label click, toggles on chevron click -->
            <div class="flex items-center gap-3 px-4 py-3 text-gray-700 hover:bg-gray-100 rounded-lg transition-colors"
                 [class.bg-gray-200]="isExpanded(item) || hasActiveChild(item) || isRouteActive(item.route)"
                 [class.text-gray-900]="isExpanded(item) || hasActiveChild(item) || isRouteActive(item.route)">
              <a
                [routerLink]="item.route"
                routerLinkActive="text-gray-900"
                [routerLinkActiveOptions]="{ exact: false }"
                class="flex items-center gap-3 flex-1"
              >
                <i [class]="item.icon + ' w-5 text-center'"></i>
                <span class="flex-1">{{ item.label }}</span>
              </a>
              <button
                (click)="toggleSubmenu(item); $event.stopPropagation()"
                class="text-gray-500 hover:text-gray-700 focus:outline-none p-1"
                type="button"
              >
                <i
                  class="fas fa-chevron-down text-xs transition-transform"
                  [class.rotate-180]="isExpanded(item)"
                ></i>
              </button>
            </div>
          } @else {
            <!-- Parent item without children - navigates normally -->
            <a
              [routerLink]="item.route"
              routerLinkActive="bg-gray-200 text-gray-900"
              [routerLinkActiveOptions]="{ exact: item.route === '/admin' }"
              class="flex items-center gap-3 px-4 py-3 text-gray-700 hover:bg-gray-100 rounded-lg transition-colors"
            >
              <i [class]="item.icon + ' w-5 text-center'"></i>
              <span class="flex-1">{{ item.label }}</span>
            </a>
          }
          
          @if (item.children && item.children.length > 0 && isExpanded(item)) {
            <ul class="ml-4 mt-1 space-y-1">
              @for (child of item.children; track child.route) {
                <li>
                  <a
                    [routerLink]="child.route"
                    routerLinkActive="text-primary font-medium bg-primary/10"
                    [routerLinkActiveOptions]="{ exact: false }"
                    class="flex items-center gap-3 px-4 py-2 text-sm text-gray-600 hover:text-gray-900 rounded-lg transition-colors"
                  >
                    <i [class]="child.icon + ' w-4 text-center'"></i>
                    <span>{{ child.label }}</span>
                  </a>
                </li>
              }
            </ul>
          }
        </li>
      }
    </ul>

    <!-- Dark Mode & Settings -->
    <div class="px-3 mt-auto space-y-1">
      <!-- <div class="flex items-center justify-between px-4 py-3 text-gray-700 hover:bg-gray-100 rounded-lg transition-colors cursor-pointer">
        <div class="flex items-center gap-3">
          <i class="fas fa-moon w-5 text-center"></i>
          <span>Dark Mode</span>
        </div>
        <label class="relative inline-flex items-center cursor-pointer">
          <input type="checkbox" class="sr-only peer" [(ngModel)]="darkMode">
          <div class="w-11 h-6 bg-gray-300 peer-focus:outline-none rounded-full peer peer-checked:after:translate-x-full peer-checked:after:border-white after:content-[''] after:absolute after:top-[2px] after:left-[2px] after:bg-white after:border-gray-300 after:border after:rounded-full after:h-5 after:w-5 after:transition-all"></div>
        </label>
      </div>
      
      <a class="flex items-center gap-3 px-4 py-3 text-gray-700 hover:bg-gray-100 rounded-lg transition-colors">
        <i class="fas fa-cog w-5 text-center"></i>
        <span>Settings</span>
      </a> -->
      
      <a 
        (click)="logout()" 
        class="flex items-center gap-3 px-4 py-3 text-gray-700 hover:bg-gray-100 rounded-lg transition-colors cursor-pointer"
      >
        <i class="fas fa-door-open w-5 text-center"></i>
        <span>Logout</span>
      </a>
    </div>
  </nav>

  <!-- User Profile Footer -->
  <div class="p-4 border-t border-gray-200">
    <div class="flex items-center gap-3">
      <div class="w-10 h-10 bg-gray-700 rounded-full flex items-center justify-center text-white font-semibold text-sm">
        {{ getInitials() }}
      </div>
      <div class="flex-1">
        <div class="text-sm font-semibold text-gray-900">{{ authService.getCurrentUser()?.fullName || 'User' }}</div>
      </div>
      <i class="fas fa-ellipsis-v text-gray-400 text-sm"></i>
    </div>
  </div>
</aside>

